import React from 'react';
import './styles.css';

// IMAGES
import { ReactComponent as UserCircle } from '../../assets/icons/user-circle.svg';

export default function NotificationCard() {
  return (
    <div className="notification-card">
      <span className="notification-photo-user">
        <UserCircle width='35' height='35' />
      </span>
      <span className="notification-info">
        <h1>Leonardo Soares <span className="notification-tag">Sindicante</span></h1>
        <p>completou a etapa “Entrevistas” da O.S 204576/2020</p>
      </span>
      <span className="notification-status">
        <p>há 3 horas</p>
        <div className='notification-circle'></div>
      </span>
    </div>
  )
}
